import React, { useEffect, useState } from "react";
import { Column, Filters } from "react-table";
import ImagerApi from "../../api/ImagerApi";
import LoadPortApi from "../../api/LoadPortApi";
import PlateApi from "../../api/PlateApi";
import IconImagePlate from "../../Icons/Command/ImageNow";
import IconMovePlateTo from "../../Icons/Command/MovePlateTo";
import IconPlateInfo from "../../Icons/Command/PlateInfo";
import IconHandScan from "../../Icons/Command/Scan";
import IconLoadport from "../../Icons/SideMenu/LoadPort";
import IconSearch from "../../Icons/SideMenu/Search";
import IconClearDropLocation from "../../Icons/TopCommandPanel/ClearAllDrop";
import IconClearFilter from "../../Icons/TopCommandPanel/ClearFilter";
import IconScanLoadPort from "../../Icons/TopCommandPanel/Scan";
import IconStoreContent from "../../Icons/TopCommandPanel/Store";
import { EDropLocationCacheStatus } from "../../Model/EDropLocationCacheStatus";
import { EModuleType } from "../../Model/EModuleType";
import { EPsrState } from "../../Model/ModuleState";
import { EPlateErrorStatus, Plate, CanMovePlate } from "../../Model/Plate";
import { PlateAddress } from "../../Model/PlateAddress";
import {
  getModuleById,
  getModulesByType,
} from "../../redux/reducers/ModuleReducer";
import {
  getModuleState,
  getStorageAvailability,
  getStorageFullCapacity,
} from "../../redux/reducers/ModuleStateReducer";
import { useTypedSelector } from "../../redux/reducers/RootReducer";
import PlateUtil from "../../Utility/PlateUtil";
import CommandPanel from "../CommandPanel/CommandPanel";
import CommandButton from "../CommandPanel/CommandPanelButton";
import CommonTable from "../Common/CommonTable";
import Header from "../Header/Header";
import LayoutContent from "../LayoutContent";
import { NavSubItemWithPermission } from "../Sidebar/NavSubItem";
import SidebarSubmenu from "../Sidebar/SidebarSubmenu";
import { getPlateAddressesOnModule } from "./../../redux/reducers/PlateAddressReducer";
import Breadcrumb from "./../Header/Breadcrumb";
import HeaderButton from "./../Header/HeaderButton";
import ClearDropLocation from "./CommandPanelViews/ClearDropLocation";
import HandScan from "./CommandPanelViews/HandScan";
import ImagePlateUsing from "./CommandPanelViews/ImagePlateUsing";
import MovePlate from "./CommandPanelViews/MovePlate";
import PlateInformation from "./CommandPanelViews/PlateInformation";
import {
  getSuiteState,
  getPlateBarcodesOnImager,
} from "../../redux/reducers/ModuleStateReducer";
import { EImagingMode } from "../../Model/EImagingMode";
import { EComponentId } from "../../Model/Permission";
import Modal from "../Common/Modal";
import WarningView from "../../WarningView";
import config from "../../config";
import { PlateAdressStatusColumnFilter } from "./PlateAdressStatusColumnFilter";
import StorageApi from "../../api/StorageApi";
import { IconClearPlateRegsitration } from "../../Icons";
import ClearPlateConfirmationModal from "./ClearPlateConfirmationModal";
import WarningWaitView from "../../WarningWaitView";
import IconUpdateAllPlateInfo from "../../Icons/TopCommandPanel/UpdateAllPlateInfo";
import IconUpdatePlateInfo from "../../Icons/Command/UpdatePlateInfo";

type Props = {
  style?: React.CSSProperties;
};

type ShowWarningAlmostFullType =
  | "NONE"
  | "STORE_CONTENTS"
  | "STORE_ACTICE_CONTENTS";

function getPlateFromPlateAddress(
  plateAddress: PlateAddress,
  plateBarcodesOnImager: string[],
  plateBarcodesOnPsr: string[]
) {
  let plate = plateAddress.usedByPlate;
  if (
    plate == null &&
    plateAddress.reservedByPlate != null &&
    (plateBarcodesOnImager.includes(plateAddress.reservedByPlate.barcode) ||
      plateBarcodesOnPsr.includes(plateAddress.reservedByPlate.barcode))
  ) {
    plate = plateAddress.reservedByPlate;
  }
  return plate;
}

const getTablePlate = (
  plateAddress: PlateAddress,
  plateBarcodesOnImager: string[],
  plateBarcodesOnPsr: string[],
  func: (plate: Plate) => string,
  nullPlaceHolder: string = ""
) => {
  const plate = getPlateFromPlateAddress(
    plateAddress,
    plateBarcodesOnImager,
    plateBarcodesOnPsr
  );
  if (plate != null) {
    return func(plate);
  } else {
    return nullPlaceHolder;
  }
};

const SCAN = "SCAN";
const STORE = "STORE";
const STORE_ACTIVE = "STORE_ACTIVE";
const MOVE = "MOVE";
const INFO = "INFO";
const HANDSCAN = "HANDSCAN";
const LOAD_PORT = "LOAD_PORT";
const IMAGEPLATE = "IMAGEPLATE";
const CLEARDROP = "CLEARDROP";
const CLEAR_FILTER = "CLEAR_FILTER";
const CLEAR_REGISTRATION = "CLEAR_REGISTRATION";
const UPDATE_ALL_PLATE_INFO = "UPDATE_ALL_PLATE_INFO";
const UPDATE_PLATE_INFO = "UPDATE_PLATE_INFO";

export default function LoadPort({ style = {} }: Props) {
  const modulesByType = useTypedSelector((state) => getModulesByType(state));
  const psrModule = modulesByType[EModuleType.PSR][0];
  const loadPort = modulesByType[EModuleType.LOADPORT][0];
  const imagers = modulesByType[EModuleType.IMAGER];
  const chambers = modulesByType[EModuleType.CHAMBER];
  const [enableUpdatePlateInfo, setEnableUpdatePlateInfo] = useState(true);
  const [showWaitingUpdatePlateInfo, setShowWaitingUpdatePlateInfo] = useState(false);

  const plateAddresses = useTypedSelector((state) =>
    getPlateAddressesOnModule(state, loadPort.identifier)
  );
  const [isModalClearPlateOpen, setIsModalClearPlateOpen] = useState(false);
  const [selectedPlateAddresses, setSelectedPlateAddresses] = useState(
    [] as PlateAddress[]
  );
  const isRowSelected = !!selectedPlateAddresses.length;

  const [commandPanel, setCommandPanel] = useState(LOAD_PORT);
  const moduleById = useTypedSelector((state) => getModuleById(state));

  const storageAvailability = useTypedSelector((state) =>
    getStorageAvailability(state)
  );
  const storageFullCapacity = useTypedSelector((state) =>
    getStorageFullCapacity(state)
  );
  const [showAlmostFullStorage, setShowAlmostFullStorage] =
    useState<ShowWarningAlmostFullType>("NONE");

  const plateBarcodesOnPsr = useTypedSelector(
    (state) =>
      getPlateAddressesOnModule(state, psrModule.identifier)
        .map((pa) => pa.usedByPlate?.barcode)
        .filter((barcode) => barcode != null) as string[],
    (next, prev) => JSON.stringify(next) === JSON.stringify(prev)
  );
  const plateBarcodesOnImager = useTypedSelector(
    (state) => getPlateBarcodesOnImager(state),
    (next, prev) => JSON.stringify(next) === JSON.stringify(prev)
  );

  const isPsrBusy = useTypedSelector(
    (state) =>
      getModuleState(state, psrModule.identifier)?.psr?.state === EPsrState.Busy
  );

  //TODO: change code below when multi chamber implemented
  const chamberState = useTypedSelector((state) =>
    getModuleState(state, chambers[0].identifier)
  );
  const almostFullThresholdInPercent =
    chamberState.chamber?.almostFullCapacityThresholdInPercent ?? 0;
  const almostFullThreshold =
    almostFullThresholdInPercent < 0
      ? 0
      : almostFullThresholdInPercent > 100
        ? 1
        : almostFullThresholdInPercent / 100;

  const isSuiteInAutomaticMode = useTypedSelector(
    (state) => getSuiteState(state).imagingMode === EImagingMode.Automatic
  );
  const [plateDropLocationCacheStatus, setPlateDropLocationCacheStatus] =
    useState(EDropLocationCacheStatus.NoDropLocationCacheExist);

  const [clearFilter, setClearFilter] = useState({
    filters: [] as Filters<PlateAddress>,
    action: () => { },
  });

  const [canMovePlateByModuleIdentifier, setCanMovePlateByModuleIdentifier] =
    useState({} as { [moduleIdentifier: string]: boolean });

  useEffect(() => {
    setCanMovePlateByModuleIdentifier({});
    if (selectedPlateAddresses.length == 0) return;
    PlateApi.canMovePlateAddress(selectedPlateAddresses).then((arr) => {
      const result: { [index: string]: boolean } = arr.reduce(
        (map: { [index: string]: boolean }, obj: CanMovePlate) => (
          (map[obj.moduleIdentifier] = obj.canMove), map
        ),
        {}
      );
      setCanMovePlateByModuleIdentifier(result);
    });
  }, [selectedPlateAddresses]);

  const back = () => {
    setCommandPanel(LOAD_PORT);
  };

  const close = () => {
    setSelectedPlateAddresses([]);
    setCommandPanel(LOAD_PORT);
  };

  const onClick = (id: string) => {
    setCommandPanel(id);
  };

  const onClearDropLocation = () => {
    if (
      plateDropLocationCacheStatus ===
      EDropLocationCacheStatus.DropLocationCacheExistOnImagerAndLims
    ) {
      setCommandPanel(CLEARDROP);
    } else {
      const barcode = getPlateFromPlateAddress(
        selectedPlateAddresses[0],
        plateBarcodesOnImager,
        plateBarcodesOnPsr
      )?.barcode;
      if (barcode) {
        ImagerApi.clearDropLocation(barcode, false).then(() =>
          setPlateDropLocationCacheStatus(
            EDropLocationCacheStatus.NoDropLocationCacheExist
          )
        );
      }
    }
  };

  const onBackFromClearDropLocation = (clearDropOverride: boolean) => {
    if (clearDropOverride) {
      setPlateDropLocationCacheStatus(
        EDropLocationCacheStatus.NoDropLocationCacheExist
      );
    }
    setCommandPanel(LOAD_PORT);
  };

  const onCancelMove = () => {
    PlateApi.cancelMovePlates(selectedPlateAddresses);
  };

  const onClearPlateRegistration = async () => {
    const plateAddress = selectedPlateAddresses[0];
    await StorageApi.clearPlateRegistration(
      plateAddress.moduleIdentifier,
      plateAddress.hotelNo,
      plateAddress.slotNo
    );
  };

  const isAllUsedByOrReservedByPlateOk =
    PlateUtil.isAllUsedByOrReservedByPlateOk(selectedPlateAddresses);
  let imagerIdentifiers = imagers.map((i) => i.identifier);

  const targetModule = [
    loadPort.identifier,
    ...chambers.map((c) => c.identifier),
    ...imagers.map((i) => i.identifier),
  ];

  const moveEnabled = targetModule.reduce(
    (canMove: boolean, currentValue: string) =>
    (canMove =
      canMove || (canMovePlateByModuleIdentifier[currentValue] ?? false)),
    false
  );

  const infoEnabled =
    selectedPlateAddresses.length === 1 && isAllUsedByOrReservedByPlateOk;
  const handScanEnabled = selectedPlateAddresses.length === 1;

  const clearDropEnabled =
    selectedPlateAddresses.length === 1 &&
    isAllUsedByOrReservedByPlateOk &&
    plateDropLocationCacheStatus !==
    EDropLocationCacheStatus.NoDropLocationCacheExist;
  const imageNowEnabled = isAllUsedByOrReservedByPlateOk;
  const isClearPlateRegDisabled =
    !isRowSelected ||
    !(
      selectedPlateAddresses.length === 1 &&
      selectedPlateAddresses[0].usedByPlate
    );

  const cancelMoveEnabled = selectedPlateAddresses.every(
    (plateAddress) =>
      plateAddress.usedByPlate != null &&
      plateAddress.usedByPlate.isQueuedForTransfer
  );

  const columns: Column<PlateAddress>[] = React.useMemo(
    () => [
      {
        Header: "Hotel",
        id: "Hotel",
        accessor: (row: PlateAddress) => row.hotelNo,
        width: 74,
      },
      {
        Header: "Slot",
        id: "Slot",
        accessor: (row: PlateAddress) => row.slotNo,
        width: 74,
      },
      {
        Header: "Project",
        id: "Project",
        accessor: (row: PlateAddress) =>
          getTablePlate(
            row,
            plateBarcodesOnImager,
            plateBarcodesOnPsr,
            (plate) => plate.projectName
          ),
      },
      {
        Header: "Experiment Name",
        id: "Experiment Name",
        accessor: (row: PlateAddress) =>
          getTablePlate(
            row,
            plateBarcodesOnImager,
            plateBarcodesOnPsr,
            (plate) => plate.experimentName
          ),
      },
      {
        Header: "Plate Id",
        id: "Plate Id",
        accessor: (row: PlateAddress) =>
          getTablePlate(
            row,
            plateBarcodesOnImager,
            plateBarcodesOnPsr,
            (plate) => (plate.plateNumber !== -1 ? plate.plateId : "Unknown")
          ),
        width: 74,
      },
      {
        Header: "Barcode",
        id: "Barcode",
        accessor: (row: PlateAddress) =>
          getTablePlate(
            row,
            plateBarcodesOnImager,
            plateBarcodesOnPsr,
            (plate) => plate.barcode
          ),
        width: 80,
      },
      {
        Header: "Plate Number",
        id: "Plate Number",
        accessor: (row: PlateAddress) =>
          getTablePlate(
            row,
            plateBarcodesOnImager,
            plateBarcodesOnPsr,
            (plate) =>
              plate.plateNumber !== -1
                ? plate.plateNumber.toString()
                : "Unknown"
          ),
      },
      {
        Header: "Status",
        id: "Status",
        accessor: (row: PlateAddress) =>
          getTablePlate(
            row,
            plateBarcodesOnImager,
            plateBarcodesOnPsr,
            (plate) =>
              PlateUtil.getPlateAddressStatus(
                plate,
                plateBarcodesOnImager,
                plateBarcodesOnPsr
              )
          ),
        Filter: PlateAdressStatusColumnFilter,
        filter: "includes",
      },
    ],
    [
      moduleById,
      JSON.stringify(plateBarcodesOnImager),
      JSON.stringify(plateBarcodesOnPsr),
    ]
  );

  useEffect(() => {
    if (selectedPlateAddresses.length === 1) {
      let plate = getPlateFromPlateAddress(
        selectedPlateAddresses[0],
        plateBarcodesOnImager,
        plateBarcodesOnPsr
      );
      if (plate != null && plate.errorStatus === EPlateErrorStatus.OK) {
        setPlateDropLocationCacheStatus(
          EDropLocationCacheStatus.NoDropLocationCacheExist
        );
        ImagerApi.isDropLocationExist(plate.barcode).then((value) => {
          if (selectedPlateAddresses.length === 1) {
            setPlateDropLocationCacheStatus(value);
          }
        });
      }
    }
  }, [
    selectedPlateAddresses,
    JSON.stringify(plateBarcodesOnImager),
    JSON.stringify(plateBarcodesOnPsr),
  ]);

  const getSelectedRowIds = () => {
    const result: number[] = [];
    selectedPlateAddresses.forEach((selected) => {
      const index = plateAddresses.findIndex((data) => {
        return selected.id === data.id;
      });
      if (index !== -1) result.push(index);
    });
    return result;
  };

  return (
    <>
      <ClearPlateConfirmationModal
        plateBarcode={selectedPlateAddresses?.[0]?.usedByPlate?.barcode ?? ""}
        isOpen={isModalClearPlateOpen}
        onCancel={() => setIsModalClearPlateOpen(false)}
        onOk={async () => {
          setIsModalClearPlateOpen(false);
          await onClearPlateRegistration();
        }}
      />

      <LayoutContent>
        <LayoutContent.Header>
          <Header>
            <Breadcrumb
              items={[
                { title: "Load Port", to: "/plate/loadport", disabled: false },
              ]}
            />
            <Header.RightSide>
              <HeaderButton
                id={CLEAR_FILTER}
                label="Clear Filter"
                icon={<IconClearFilter />}
                disabled={clearFilter.filters.length === 0}
                onClick={() => {
                  clearFilter.action();
                }}
              />

              <HeaderButton
                id={SCAN}
                label="Scan Load Port"
                icon={<IconScanLoadPort />}
                disabled={isPsrBusy}
                onClick={() => {
                  LoadPortApi.Scan(loadPort.identifier);
                }}
              />

              <HeaderButton
                id={STORE}
                label="Store Content"
                icon={<IconStoreContent />}
                onClick={() => {
                  if (
                    (chamberState.chamber?.enableAlmostFullCapacityWarning ??
                      false) &&
                    storageAvailability <=
                    storageFullCapacity -
                    config.STORAGE_ALMOST_FULL_THRESHOLD *
                    storageFullCapacity
                  ) {
                    setShowAlmostFullStorage("STORE_CONTENTS");
                  } else {
                    LoadPortApi.storeContents(loadPort.identifier);
                  }
                }}
              />

              <HeaderButton
                id={STORE_ACTIVE}
                label="Store Active Content"
                icon={<IconStoreContent />}
                onClick={() => {
                  if (
                    (chamberState.chamber?.enableAlmostFullCapacityWarning ??
                      false) &&
                    storageAvailability <=
                    storageFullCapacity -
                    almostFullThreshold * storageFullCapacity
                  ) {
                    setShowAlmostFullStorage("STORE_ACTICE_CONTENTS");
                  } else {
                    LoadPortApi.storeActiveContents(loadPort.identifier);
                  }
                }}
              />

              <HeaderButton
                id={UPDATE_ALL_PLATE_INFO}
                label="Update All Plate Info"
                icon={<IconUpdateAllPlateInfo />}
                onClick={async () => {
                  setEnableUpdatePlateInfo(false);
                  setShowWaitingUpdatePlateInfo(true);
                  try {
                    await PlateApi.updatePlateInfo([]);
                  }
                  finally {
                    setShowWaitingUpdatePlateInfo(false);
                    setEnableUpdatePlateInfo(true);
                  }
                }}
                disabled={!enableUpdatePlateInfo}
              />

              {/* <HeaderButton
              id={EJECT}
              label="Eject"
              icon={<IconEject />}
              onClick={() => {
                LoadPortApi.ejectLoadPort(loadPort.identifier);
              }}
            />

            <HeaderButton
              id={RETRACT}
              label="Retract"
              icon={<IconEject />}
              onClick={() => {
                LoadPortApi.retractLoadPort(loadPort.identifier);
              }}
            /> */}
            </Header.RightSide>
          </Header>
        </LayoutContent.Header>

        <LayoutContent.SubMenu>
          <SidebarSubmenu>
            <NavSubItemWithPermission
              componentId={EComponentId.PlateLoadPort}
              label="Load Port"
              key="loadport"
              to="/plate/loadport"
              icon={<IconLoadport />}
            />
            <NavSubItemWithPermission
              componentId={EComponentId.PlateSearch}
              label="Search"
              key="search"
              to="/plate/search"
              icon={<IconSearch />}
            />
          </SidebarSubmenu>
        </LayoutContent.SubMenu>

        <LayoutContent.Content>
          <CommonTable<PlateAddress>
            setClearFilter={setClearFilter}
            initialSelectedRowIndexes={getSelectedRowIds()}
            setSelectedRows={(rows) => {
              setSelectedPlateAddresses((prev) => {
                if (JSON.stringify(prev) === JSON.stringify(rows)) return prev;
                setCommandPanel(LOAD_PORT);
                return rows;
              });
            }}
            data={plateAddresses}
            columns={columns}
            hidePaginationIfNotNeeded={true}
            getRowStyle={(plateAddress, isSelected) =>
              PlateUtil.getPlateAddressRowStyle(
                moduleById,
                plateAddress,
                isSelected,
                plateBarcodesOnImager,
                plateBarcodesOnPsr
              )
            }
            sortingRules={[
              {
                id: "Hotel",
              },
              {
                id: "Slot",
              },
            ]}
            style={{
              height: "100%",
            }}
          />
          <Modal
            show={showAlmostFullStorage !== "NONE"}
            hideOnBackdropClick={false}
            onHide={() => setShowAlmostFullStorage("NONE")}
          >
            <Modal.Body>
              <WarningView
                title="Storage Warning"
                message="Plate Storage is getting full, Please remove expired plate"
                instruction={`You have ${storageAvailability} available slots`}
                onClickOk={() => {
                  switch (showAlmostFullStorage) {
                    case "STORE_ACTICE_CONTENTS":
                      LoadPortApi.storeActiveContents(loadPort.identifier);
                      break;
                    case "STORE_CONTENTS":
                      LoadPortApi.storeContents(loadPort.identifier);
                      break;
                  }
                  setShowAlmostFullStorage("NONE");
                }}
              />
            </Modal.Body>
          </Modal>
          <Modal
            show={showWaitingUpdatePlateInfo}
            hideOnBackdropClick={false}
            style={{
              width: 686,
              minHeight: 422,
            }}
          >
            <Modal.Body>
              <WarningWaitView
                title="Updating plate information"
                message={"Please wait,\n Updating plate information... "}
              />
            </Modal.Body>
          </Modal>
        </LayoutContent.Content>
        <LayoutContent.CommandPanel>
          <>
            {commandPanel === LOAD_PORT && (
              <CommandPanel>
                <CommandPanel.PlateInfoHeader
                  plateAddresses={selectedPlateAddresses}
                />
                <CommandPanel.HorizontalContent>
                  <CommandButton
                    id={IMAGEPLATE}
                    icon={<IconImagePlate />}
                    content="Image Now"
                    disabled={!imageNowEnabled || !isRowSelected}
                    onClick={(id) => onClick(id)}
                    showArrow={true}
                  />
                  {!cancelMoveEnabled && (
                    <CommandButton
                      id={MOVE}
                      icon={<IconMovePlateTo />}
                      content="Move Plate To"
                      disabled={!moveEnabled || !isRowSelected}
                      onClick={(id) => onClick(id)}
                      showArrow={true}
                    />
                  )}

                  {cancelMoveEnabled && (
                    <CommandButton
                      id={MOVE}
                      icon={<IconMovePlateTo />}
                      content="Cancel store plate(s)"
                      disabled={!isRowSelected}
                      onClick={onCancelMove}
                      showArrow={false}
                    />
                  )}

                  <CommandButton
                    id={INFO}
                    icon={<IconPlateInfo />}
                    content="Plate Information"
                    disabled={!infoEnabled || !isRowSelected}
                    onClick={(id) => onClick(id)}
                    showArrow={true}
                  />
                  <CommandButton
                    id={HANDSCAN}
                    icon={<IconHandScan />}
                    content="Hand Scan"
                    disabled={!handScanEnabled || !isRowSelected}
                    onClick={(id) => onClick(id)}
                    showArrow={true}
                  />
                  <CommandButton
                    id={CLEARDROP}
                    icon={<IconClearDropLocation fill="#414042" />}
                    content="Clear All Drop Locations"
                    disabled={!clearDropEnabled || !isRowSelected}
                    onClick={(id) => onClearDropLocation()}
                    showArrow={
                      plateDropLocationCacheStatus ===
                      EDropLocationCacheStatus.DropLocationCacheExistOnImagerAndLims
                    }
                  />
                  <CommandButton
                    id={CLEAR_REGISTRATION}
                    icon={<IconClearPlateRegsitration />}
                    content="Clear Registration"
                    disabled={isClearPlateRegDisabled}
                    onClick={() => setIsModalClearPlateOpen(true)}
                  />

                  <CommandButton
                    id={UPDATE_PLATE_INFO}
                    icon={<IconUpdatePlateInfo />}
                    content="Update Plate Info"
                    disabled={!isRowSelected || !enableUpdatePlateInfo}
                    onClick={async () => {
                      const barcodes = selectedPlateAddresses.map(pa => pa.usedByPlate?.barcode ?? pa.reservedByPlate?.barcode ?? "").filter(bc => bc !== "");
                      setEnableUpdatePlateInfo(false);
                      try {
                        await PlateApi.updatePlateInfo(barcodes);
                      }
                      finally {
                        setEnableUpdatePlateInfo(true);
                      }
                    }}
                  /> *
                </CommandPanel.HorizontalContent>
              </CommandPanel>
            )}
            {commandPanel === HANDSCAN && (
              <HandScan
                plateAddress={selectedPlateAddresses[0]}
                backBtn={back}
              />
            )}
            {commandPanel === INFO && (
              <PlateInformation
                plateAddress={selectedPlateAddresses[0]}
                backBtn={back}
              />
            )}
            {commandPanel === MOVE && (
              <MovePlate
                canMovePlateByModuleIdentifier={canMovePlateByModuleIdentifier}
                plateAddresses={selectedPlateAddresses}
                back={back}
                close={close}
              />
            )}

            {commandPanel === IMAGEPLATE && (
              <ImagePlateUsing
                plateAddresses={selectedPlateAddresses}
                back={back}
                close={close}
                showImageDrop={false}
              />
            )}
            {commandPanel === CLEARDROP && (
              <ClearDropLocation
                plateAddress={selectedPlateAddresses[0]}
                backBtn={onBackFromClearDropLocation}
              />
            )}
          </>
        </LayoutContent.CommandPanel>
      </LayoutContent>
    </>
  );
}
